import { PreSaleHeatmapApiModel } from '@/common/models';
import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import UserNotifications from '@/utils/UserNotifications';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  createNewPreSaleHeatmap({ commit }, params) {
    const preSaleHeatmap = PreSaleHeatmapApiModel.fromObject(params);
    commit(types.CREATE_PRESALEHEATMAP, preSaleHeatmap);
    return preSaleHeatmap;
  },

  deletePreSaleHeatmaps({ commit }, preSaleHeatmaps) {
    return new Promise((resolve, reject) => {
      GlobalEventBus.$emit(GlobalEvents.loading);

      let successfullApiCalls = 0;
      let failedApiCalls = 0;

      const evalCompletion = () => {
        if (successfullApiCalls + failedApiCalls === preSaleHeatmaps.length) {
          if (successfullApiCalls === preSaleHeatmaps.length) {
            resolve(true);
            GlobalEventBus.$emit(GlobalEvents.loaded);
          } else {
            reject();
            const msg = i18n.global.t('messages.failedToDeletePreSaleHeatmaps');
            UserNotifications.error({ message: `${msg}` });
            GlobalEventBus.$emit(GlobalEvents.loaded);
          }
        }
      };

      preSaleHeatmaps.forEach((preSaleHeatmap) => {
        API.instance.deletePreSaleHeatmap(
          preSaleHeatmap.id,
          () => {
            commit(types.DELETE_PRESALEHEATMAP, preSaleHeatmap);
            successfullApiCalls += 1;
            evalCompletion();
          },
          () => {
            failedApiCalls += 1;
            evalCompletion();
          },
        );
      });
    });
  },

  deletePreSaleHeatmap({ commit }, preSaleHeatmap) {
    return new Promise((resolve, reject) => {
      GlobalEventBus.$emit(GlobalEvents.loading);

      API.instance.deletePreSaleHeatmap(
        preSaleHeatmap.id,
        () => {
          commit(types.DELETE_PRESALEHEATMAP, preSaleHeatmap);
          resolve(true);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToDeletePreSaleHeatmap');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },

  getPreSaleHeatmaps({ commit }, queryParams) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    return new Promise((resolve, reject) => {
      API.instance.getPreSaleHeatmaps(
        queryParams,
        (result) => {
          commit(types.UPDATE_PRESALEHEATMAPS_LIST, result.items);
          resolve(result);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToGetPreSaleHeatmaps');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },

  getPreSaleHeatmap({ commit }, id) {
    return new Promise((resolve, reject) => {
      GlobalEventBus.$emit(GlobalEvents.loading);
      API.instance.getPreSaleHeatmap(
        id,
        (preSaleHeatmap) => {
          commit(types.UPDATE_PRESALEHEATMAP, preSaleHeatmap);
          resolve(preSaleHeatmap);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToGetPreSaleHeatmap');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },

  getPublicPreSaleHeatmap({ commit }, { uuid, password }) {
    return new Promise((resolve, reject) => {
      GlobalEventBus.$emit(GlobalEvents.loading);
      API.instance.getPublicPreSaleHeatmap(
        uuid,
        password,
        (preSaleHeatmap) => {
          resolve(preSaleHeatmap);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToGetPreSaleHeatmap');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },

  savePreSaleHeatmap({ commit }, preSaleHeatmap) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    return new Promise((resolve, reject) => {
      const successCallback = (data) => {
        commit(types.SAVE_PRESALEHEATMAP, data);
        resolve(data);
        GlobalEventBus.$emit(GlobalEvents.loaded);
      };

      const errorCallback = (error) => {
        const msg = i18n.global.t('messages.failedToSavePreSaleHeatmap');
        ErrorHandler.showError(msg, error);
        reject(error);
        GlobalEventBus.$emit(GlobalEvents.loaded);
      };

      if (preSaleHeatmap.id === -1) {
        API.instance.postPreSaleHeatmap(preSaleHeatmap, successCallback, errorCallback);
      } else {
        API.instance.putPreSaleHeatmap(preSaleHeatmap, successCallback, errorCallback);
      }
    });
  },

  uploadPreSaleHeatmapFile({ commit }, file) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    return new Promise((resolve, reject) => {
      API.instance.uploadPreSaleHeatmapFile(
        file,
        (data) => {
          resolve(data);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToSavePreSaleHeatmap');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },
};

export default actions;
